<template>
  <div v-show="isVisibleInternal" class="loading-indicator" :class="`loading-indicator--${type}`">
    <div v-if="isSpinnerType" class="loading-indicator__element" />
    <IconLoader v-else class="loading-indicator__element" />
  </div>
</template>

<script>
import IconLoader from '@/components/_icons/IconLoader.svg'

export const LOADING_INDICATOR_TYPES = {
  default: 'default', // displays "cloud" as well, but without additional styles for backwards compatibility
  cloud: 'cloud',
  cloudCentered: 'cloud-centered',
  spinner: 'spinner',
}

export default {
  name: 'LoadingIndicator',

  components: {
    IconLoader,
  },

  props: {
    /**
     * Toggles visibility.
     */
    isVisible: {
      type: Boolean,
      default: true,
    },
    /**
     * Defines visual type.
     */
    type: {
      type: String,
      default: LOADING_INDICATOR_TYPES.default,
      validator(value) {
        return Object.values(LOADING_INDICATOR_TYPES).includes(value)
      },
    },
    /**
     * Makes it show up only after "displayDelay" has passed.
     */
    hasDelayedDisplay: {
      type: Boolean,
      default: false,
    },
    /**
     * Is only applied if "hasDelayedDisplay" is set to "true".
     */
    displayDelay: {
      type: Number,
      default: 700,
    },
  },

  data() {
    return {
      isVisibleInternal: true,
      displayDelayTimeoutId: null,
    }
  },

  computed: {
    isSpinnerType() {
      return this.type === LOADING_INDICATOR_TYPES.spinner
    },
  },

  watch: {
    isVisible: {
      immediate: true,
      handler() {
        if (this.isVisible && this.hasDelayedDisplay) {
          this.displayDelayTimeoutId = setTimeout(() => {
            this.isVisibleInternal = true
          }, this.displayDelay)
        } else {
          clearTimeout(this.displayDelayTimeoutId)
          this.isVisibleInternal = this.isVisible
        }
      },
    },
  },
}
</script>

<style scoped lang="scss">
$icon_size: 50px;
.loading-indicator {
  // we cannot add "loader" class since styles from loader.scss would be applied
  &__element {
    width: $icon_size;
    height: $icon_size;
  }

  /deep/ .path {
    fill: none;
    stroke: #ccc;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1;
    stroke-dasharray: 60 62;
    stroke-dashoffset: 61;
    animation: draw 0.8s ease-in-out 0s infinite alternate-reverse;

    &__bg {
      animation: none;
      opacity: 0.3;
      stroke-dashoffset: 0;
    }

    @keyframes draw {
      0% {
        stroke-dashoffset: 61;
      }
      100% {
        stroke-dashoffset: 0;
      }
    }
  }

  &--cloud {
    .loading-indicator__element {
      position: relative;
      transform: translate(-50%, -50%);
    }
  }

  &--cloud-centered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    width: $icon_size;
  }

  &--spinner {
    .loading-indicator__element {
      position: relative;

      &:before {
        @include spinner-centered(28px, $color-black, 1px);
      }
    }
  }
}
</style>
